import { useMantineTheme, Box } from '@mantine/core';
import { ReactNode, use } from 'react';
import { HeaderSimple } from '../../components/Header/HeaderSimple';
import { useEntity } from '../../contexts/EntityContext';

interface LayoutProps {
  children: ReactNode;
  // showHeader?: boolean;
  logOut: () => void;
  user: any;
  entity: any;
  setEntity: any;
  setCambiarEntitatModalOpened: any;
}

export function Layout(props: LayoutProps) {
  const theme = useMantineTheme();
  const { entityName, setEntityName } = useEntity();

  // if (props.showHeader) {
    return (
      <>
        <HeaderSimple 
          entitatsData={props.user?.user?.entitats || []}
          logOut={props.logOut}
          entity={props.entity}
          setEntity={props.setEntity}
          tramits={props.user?.user.tramits}
          trameses={props.user?.user.trameses}
          setCambiarEntitatModalOpened={props.setCambiarEntitatModalOpened}
          // entityName={props.user?.user?.entitats.length > 1 ? entityName : props.user?.user?.entitats[0]?.lookupValue || ''}
          onEntityChange={setEntityName}
          userName={props.user?.user?.displayName || ''}
        />
        <Box
          style={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: theme.other.fullWidthBackground || '#fff',
            padding: '24px',
            paddingTop: '64px',
          }}
        >
          {props.children}
        </Box>
      </>
    );
  // }

  // return (
  //   <Box style={{ width: '100%', minHeight: '100vh' }}>
  //     {props.children}
  //   </Box>
  // );
}
